/* eslint-disable @typescript-eslint/no-unsafe-function-type */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { getDateString } from "@/util";
import { useNavigate } from "react-router";

//------------------------
interface Prop_GameListRow {
  game_code: string;
  write_date: string;
  is_opened:boolean;
  subject: string;
  showLine?: boolean;
  onClick?: () => void;
}
export function GameListRow(prop: Prop_GameListRow) {

  return (
    <div className="      
      flex flex-col w-full 
      cursor-pointer select-none"
    >
      <div className={`
        p-2 px-1        
        hover:bg-zinc-100 transition-colors
        `}
        onClick={() => prop.onClick && prop.onClick()}
      >
        <div className={`
          w-full flex gap-2 items-center
        `}>
          <div className="text-zinc-500">
            {getDateString("yyyy-MM-dd", new Date(prop.write_date))}
          </div>
          <div className="flex-1">
            {/* <Editor viewMode={true} html={prop.subject} className="text-nowrap break-keep" /> */}
            <div dangerouslySetInnerHTML={{__html:prop.subject}}className="text-nowrap break-keep" />
          </div>
          {prop.is_opened?
            <div className="w-[50px] text-nowrap text-center p-2 py-0.5 bg-green-500 text-white rounded-md">게시중</div>:
            <div className="w-[50px] text-nowrap text-center p-2 py-0.5 bg-red-500 text-white rounded-md">닫힘</div>
          }
        </div>
      </div>
      {prop.showLine && (
        <div className="w-full border-dashed border-b border-zinc-300" />
      )}
    </div>
  );
}

//------------------------

interface Prop_ViewGameList {
  className?: string;
  data?: Array<any>;
  onUpdate?:(info:unknown)=>void;
}
export default function GameListView(prop: Prop_ViewGameList) {
  const navi = useNavigate();

  return (
    prop.data &&
    prop.data.map((v: any, i: number) => (
      <GameListRow
        key={v.game_code}
        {...v}
        showLine={prop.data!.length - 1 > i}
        onClick={() =>navi(`/admin/game-setup/${v.game_code}`)}
      />
    ))
  );
}
